import styled from 'styled-components'
import Link from 'next/link'
import MedalistsTitle from '../MedalistsTitle'
import MedalistPhase2Card from '../../MedallistPhase2Card'
import MedalistPhase2Category from '../../MedalistPhase2Category'
import useMedalistsPhase2 from '../../../../hooks/useMedalistsPhase2'

const ModuleMedallistsPhase2 = (props: any) => {
  const { labelsData, groupByCategory } = useMedalistsPhase2()

  return (
    <StyledComponent className='px-0 snap-section-start'>
      <div className='theme-black snap-section-start hide-floating-logos relative top-[10px] pt-[85px] md:pt-[185px] lg:pt-[200px]' />
      {/* Make a 12 column grid with Tailwind */}
      <div className='wrapper'>
        <MedalistsTitle title={props.medallistBlockHeading} brief={props.medallistBlockHeadingBrief} />
        <div className='px-[12px] lg:px-[18px]'>
          {groupByCategory?.IconArtist?.length > 0 && (
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.IconArtist || '{IconArtist}'} />
              <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-4'>
                {groupByCategory?.IconArtist?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-80px)/6)]'>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
          )}
          {groupByCategory?.EstablishedArtist?.length > 0 && (
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.EstablishedArtist || '{EstablishedArtist}'} />
              <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-4'>
                {groupByCategory?.EstablishedArtist?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-80px)/6)]'>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
          )}
          {groupByCategory?.EmergingArtist?.length > 0 && (
            <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
              <MedalistPhase2Category text={labelsData?.MedalistCategories?.EmergingArtist || '{EmergingArtist}'} />
              <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-4'>
                {groupByCategory?.EmergingArtist?.map((item: any) => (
                  <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-80px)/6)]'>
                    <MedalistPhase2Card
                      key={item.id}
                      name={item.attributes.name}
                      $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                    />
                  </Link>
                ))}
              </div>
            </div>
          )}
          {(groupByCategory?.CrossDisciplinaryCreator?.length > 0 || groupByCategory?.Patrons?.length > 0) && (
            <div className='group-section grid grid-col-1 lg:grid-cols-2 gap-2 lg:gap-4'>
              {groupByCategory?.CrossDisciplinaryCreator?.length > 0 && (
                <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
                  <MedalistPhase2Category text={labelsData?.MedalistCategories?.CrossDisciplinaryCreator || '{CrossDisciplinaryCreator}'} />
                  <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-[16px]'>
                    {groupByCategory?.CrossDisciplinaryCreator?.map((item: any) => (
                      <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-32px)/3)]'>
                        <MedalistPhase2Card
                          key={item.id}
                          name={item.attributes.name}
                          $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              )}
              {groupByCategory?.Patrons?.length > 0 && (
                <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
                  <MedalistPhase2Category text={labelsData?.MedalistCategories?.Patrons || '{Patrons}'} />
                  <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-[16px]'>
                    {groupByCategory?.Patrons?.map((item: any) => (
                      <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-32px)/3)]'>
                        <MedalistPhase2Card
                          key={item.id}
                          name={item.attributes.name}
                          $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          {(groupByCategory?.MuseumsAndInstitutions?.length > 0 || groupByCategory?.Curator?.length > 0) && (
            <div className='group-section grid grid-col-1 lg:grid-cols-2 gap-2 lg:gap-4'>
              {groupByCategory?.MuseumsAndInstitutions?.length > 0 && (
                <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
                  <MedalistPhase2Category text={labelsData?.MedalistCategories?.MuseumsAndInstitutions || '{MuseumsAndInstitutions}'} />
                  <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-[16px]'>
                    {groupByCategory?.MuseumsAndInstitutions?.map((item: any) => (
                      <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-32px)/3)]'>
                        <MedalistPhase2Card
                          key={item.id}
                          name={item.attributes.name}
                          $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              )}
              {groupByCategory?.Curator?.length > 0 && (
                <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
                  <MedalistPhase2Category text={labelsData?.MedalistCategories?.Curator || '{Curator}'} />
                  <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-[16px]'>
                    {groupByCategory?.Curator?.map((item: any) => (
                      <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-32px)/3)]'>
                        <MedalistPhase2Card
                          key={item.id}
                          name={item.attributes.name}
                          $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
          {(groupByCategory?.MediaAndStorytelling?.length > 0 || groupByCategory?.Allies?.length > 0) && (
            <div className='group-section grid grid-col-1 lg:grid-cols-2 gap-2 lg:gap-4'>
              {groupByCategory?.MediaAndStorytelling?.length > 0 && (
                <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
                  <MedalistPhase2Category text={labelsData?.MedalistCategories?.MediaAndStorytelling || '{MediaAndStorytelling}'} />
                  <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-[16px]'>
                    {groupByCategory?.MediaAndStorytelling?.map((item: any) => (
                      <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-32px)/3)]'>
                        <MedalistPhase2Card
                          key={item.id}
                          name={item.attributes.name}
                          $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              )}
              {groupByCategory?.Allies?.length > 0 && (
                <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
                  <MedalistPhase2Category text={labelsData?.MedalistCategories?.Allies || '{Allies}'} />
                  <div className='flex flex-wrap justify-center gap-2 md:gap-[18px] lg:gap-[16px]'>
                    {groupByCategory?.Allies?.map((item: any) => (
                      <Link key={item.id} href={`/medalist/${item.id}`} className='w-[calc((100%-16px)/3)] md:w-[calc((100%-36px)/3)] lg:w-[calc((100%-32px)/3)]'>
                        <MedalistPhase2Card
                          key={item.id}
                          name={item.attributes.name}
                          $medalistImage={item.attributes.medallistPhaseTwoImage?.data?.attributes?.url}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </StyledComponent>
  )
}

const StyledComponent = styled.div<any>`
  scroll-snap-align: start;
  min-height: 100vh;
  > div.wrapper {
    justify-content: center;
    margin: 0 auto;
    align-items: center;
  }
`

export default ModuleMedallistsPhase2
